{
  "shared": {
    "upload": {
      "dropHint": "اختر ملفًا أو اسحبه إلى هنا.",
      "limit": "الحد الأقصى لحجم الملف: {{size}} ميجابايت.",
      "tooLarge": "اختر ملفًا لا يتجاوز حجمه {{size}} ميجابايت. يبقى اختيارك السابق محفوظًا.",
      "wrongType": "اختر أحد أنواع الملفات الموضحة لهذا المستند. يبقى اختيارك السابق محفوظًا.",
      "oneFile": "اختر ملفًا واحدًا في كل مرة.",
      "selected": "الملف المحدد",
      "remove": "إزالة الملف",
      "sending": "جارٍ إرسال الملف. انتظر نتيجة الخادم."
    }
  }
}
